import useTableRowConfig from "../hooks/useTableRowConfig";
import TableCell from "./TableCell";
import styles from "./table.module.css";

const TableRow = ({ config, data, ...rest }) => {
  const { tableRowConfig } = useTableRowConfig(config);

  return (
    <tr className={styles.tableRow} {...rest}>
      {tableRowConfig.map((cellConfig) => {
        if (cellConfig?.formOnly === true) return null;
        return (
          <TableCell key={cellConfig.id} config={cellConfig} data={data} />
        );
      })}
    </tr>
  );
};

export default TableRow;
